import { jsx as n, Fragment as d, jsxs as m } from "react/jsx-runtime";
import { Typography as i } from "@mui/material";
import o from "@mui/material/Grid";
import { AssessmentTaskResultTypeEnum as s } from "../../helpers/daymaptypes.js";
import { RubricSummary as u } from "./Rubrics.js";
const v = ({ task: e, outcomes: c, results: a, studentId: r }) => {
  if (!a || a.length === 0)
    return /* @__PURE__ */ n(d, {});
  switch (e.ResultType) {
    case s.LearningArea:
    case s.FixedOutcomes:
      return /* @__PURE__ */ n(l, { task: e, outcomes: c, results: a, studentId: r });
    case s.Gradebook:
      return /* @__PURE__ */ n(h, { task: e, outcomes: c, results: a, studentId: r });
  }
  return null;
}, l = ({ outcomes: e, results: c }) => /* @__PURE__ */ n(o, { container: !0, spacing: 2, children: e.map((a) => {
  const r = c.find((t) => t.ResultId === a.ResultID);
  return !r || !r.Comments && !r.Grade ? null : /* @__PURE__ */ m(o, { size: { xs: r.Comments ? 12 : 6 }, children: [
    /* @__PURE__ */ n(i, { variant: "caption", children: a.Label }),
    /* @__PURE__ */ n(i, { children: r.Comments || r.Grade })
  ] });
}) }), h = ({ task: e, results: c, studentId: a }) => {
  if (c.length === 0)
    return null;
  const r = [], t = c[0];
  return e.Marked && t.Mark && r.push(/* @__PURE__ */ m(o, { size: { xs: 6 }, children: [
    /* @__PURE__ */ n(i, { variant: "caption", component: "div", children: "Mark" }),
    /* @__PURE__ */ n(i, { variant: "h6", component: "span", children: t.Mark }),
    /* @__PURE__ */ m(i, { variant: "body2", component: "span", children: [
      " out of ",
      e.MaxMark
    ] })
  ] }, "mark")), t.Grade && r.push(/* @__PURE__ */ m(o, { size: { xs: 6 }, children: [
    /* @__PURE__ */ n(i, { variant: "caption", children: "Grade" }),
    /* @__PURE__ */ n(i, { variant: "h6", children: t.Grade })
  ] }, "grade")), e.RubricID && r.push(/* @__PURE__ */ m(o, { size: { xs: 12 }, children: [
    /* @__PURE__ */ n(i, { variant: "caption", children: "Rubric Summary" }),
    /* @__PURE__ */ n(u, { studentId: a, taskId: e.ID, rubricId: e.RubricID }, "rubric summary")
  ] }, "rubric summary")), t.Comments && r.push(/* @__PURE__ */ m(o, { size: { xs: 12 }, children: [
    /* @__PURE__ */ n(i, { variant: "caption", children: "Comments" }),
    /* @__PURE__ */ n(i, { children: t.Comments })
  ] }, "comments")), /* @__PURE__ */ n(o, { container: !0, spacing: 2, children: r });
};
export {
  v as StudentResults
};
//# sourceMappingURL=StudentResults.js.map
